import { Component, OnInit } from '@angular/core';
import {Product} from "../../../../../../models/Product";
import {ProductsService} from "../../../../../../services/products/products.service";
import {ToastrService} from "ngx-toastr";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-product-info',
  templateUrl: './product-info.component.html',
  styleUrls: ['./product-info.component.scss']
})
export class ProductInfoComponent implements OnInit {
    productId!: number;
    productData: any = {};
  constructor( private productsService : ProductsService,private route: ActivatedRoute, private toastr: ToastrService ) { }

  ngOnInit(): void {
      this.productId = +this.route.parent?.snapshot.paramMap.get('id')!;
      this.getProduct();
  }
    getProduct(): void {
        this.productsService.getDetailsProduct(this.productId).subscribe({
            next: (response: Product) => {
                this.productData = response;
                // console.log(this.productData);
            },
            error: (err) => {
                this.toastr.error('Erreur lors du chargement du produit');
            }
        });
    }
}
